import React, { useState } from "react";
import { Link } from "react-router-dom";

import Button from 'react-bootstrap/Button';

import Rating from '../Rating/Rating';

import './LinkItem.css';

const words = /(\S+\s+){1,20}(\w+\.)?/;

/**
 * Get first 10 words of text or first sentence up to period,
 * whichever is shorter.
 *
 * @param {string} descr
 */
function shorten(descr) {
  const shortened = descr.match(words);
  return (shortened && shortened[0]) || descr;
}

function storeName(url) {
  if (! url) {
    return '';
  }
  const re = /\/\/(.*?)([^/.]+\.[^/.]+)\//;
  const matches = url.match(re)
  return matches ? (matches[2] === 'amzn.to' ? 'Amazon' : matches[2]) : url;
}

function capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

function LinkItem({ link: { image, name, _id, url, description, dealText, rating, ali } }) {
  const [ copied, setCopied ] = useState(false);

  function copyCodeToClipboard(code) {
    navigator.clipboard.writeText(code).then(
        () => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        },
        () => { /* clipboard write failed */ },
      );
  }

  return (
    <div className="card p-3 m-2 product-card">
      <a href={url}>
        {image ? <img alt={name} src={`/image/${image}`} /> : null}
        <h3>{name}</h3>
      </a>

      {rating ? <Rating stars={rating} /> : null}

      <p>
        {description}
        {/*<Link to={`affiliate/${_id}`}>Read&nbsp;more</Link>*/}
      </p>

      <div>
        {dealText ? <div className="deal">{dealText}</div> : null}
      </div>

      {
        ali && ali.codeName ?
          <div className="card-button coupon-code" onClick={() => copyCodeToClipboard(ali.codeName)}>{ali.codeName} {copied ? null :  <i className="bi bi-copy"></i>}{copied ? <span>&nbsp;copied <i className="bi bi-check-lg"></i></span> : null}</div> :
          <Button className="card-button shop-link-small" href={url}>
            View on {capitalizeFirstLetter(storeName(url))}
          </Button>
      }

    </div>
  );
}

export default LinkItem;
